import React,{useState,useContext} from 'react';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import BookSite from './BookSite';
import './style.css'
import './css/style.css';
import Navigation from './components/Navigation/Navigation.js';
import Showcase from './components/Showcase/Showcase.js';
import Cards from './components/Cards/Cards.js';
import About from './components/About/About.js';
import Author from './components/Author/Author.js';
import Contact from './components/Contact';
import Footer from './components/Footer/Footer.js';
import GradeLessons from './components/GradeLessons/GradeLessons.js';
import Log_in from './components/Log_in/Log_in.js';
import Sign_in from './components/Sign_in';
import {context} from './context'

export default function App(){
	const [showInfo, setShowInfo] = useState(false);
	const {showItem,setShowItem,id} = useContext(context)
	
	return(
		<div>
		{
			showItem === 'home'
		
		?
			
			<div className="container">

				<img src="img/logo_1.png" alt="logo" className="logo"/>

				<main className="header">
				  <span className="text-hi">
				  	<strong>Hi!</strong>
				    <img src="img/hi.png" alt="hi" className="img-hi"/>
				  </span>
				  <p>
				    I am <strong>Dalia Gadelhak,</strong> a passionate frontend developer,<br/> who focuses on building beautiful
				    interfaces<br/>
				    using the latest web technologies.
				  </p>
				  <button 
				  	className="btn-info"
				  	onClick={()=>setShowInfo(true)}
				  >
				  	Get In Touch
				  </button>
				</main>

				<section className="qualifications-info">
				  <div className="about-me">
				    <h2 style={{marginTop: '2rem'}}> About me</h2>
				    <br/>
				    4+ years of professional experience in implementing<strong> Friendly User Interface</strong> using HTML5, CSS3,
				    SASS, JAVASCRIPT,ES6, JQUERY, REACT.<br/><br/>
				    Always seeks learning the latest Web Technologies.Now, I am learning REDUX and I am ready to learn new
				    programming languages.<br/><br/>
				    I believe anything can be easily achieved by committing to the magical word <strong>"DEDICATION".</strong>
				  </div>
				  <div className="process">
				    <h2 style={{marginTop: '2rem'}}> The Process</h2>
				    <br/>
				    In all projects, I was responsible for implementing all the HTML,CSS and JS for interaction. This process
				    involves:<br/>
				    <ul className="ul">
				      <li>Analyzing and dividing design mockups for creating appropriate UI components.</li><br/>
				      <li>Using BEM methodology inorder to make my code neater and clearer.</li><br/>
				      <li>Collaborating with UI/UX designers as well as backend team.</li>
				      <br/>
				       <button className="btn-inline"><a href='../my resume.pdf' target='_blank'>My Resume</a><span>&rarr;</span></button>
					   <br/>
				        <button className="btn-inline"><a href='../mein Lebenslauf.pdf' target='_blank'>German Resume</a><span>&rarr;</span></button> 
				    </ul>
				  </div>
				  <div className="skills">
				    <h2 style={{marginTop: '2rem'}}> Qualifications & Personal skills</h2><br/>
				    <ul className="ul">
				      <li>Bachelor degree in English language.</li>
				      <li>Very good skills in : HTML5, CSS3, BOOTSTRAP4, SASS, JQUERY, JS, REACT, REACT HOOKS, Redux.</li>
				      <li>Other Skills: Git, Wepback, Babel, npm, yarn, Scrum/agile methodology.</li>
				      <li>Speaks fluent German, English, Arabic and<br/>little French.</li>
				      <li>Self Learner and never gives up.</li>
				      <li>Can manage alone her job tasks and at the same time appreciates Team Work.</li>
				      <li>Love and talented in making good communications.</li>
				    </ul>
				  </div>
				</section>


				<h3 className="project-title">SAMPLE FOR MY PROJECTS</h3>
				<section className="projects">
				  <div className="react">
				    <p className="react__paragraph">
				      In this project, I used React Hooks and React Bootstrap to create an awesome educational website. I also connected the server-side by
				      consuming 'Rest-API' to get data dynamically.
				    </p>
				    <button className="btn" onClick={()=>setShowItem('book site')}>
				        <span className="btn__visible" style={{marginLeft:"30px"}}>Click Here!</span>
				        <span className="btn__invisible">See Full Project!</span>
				    </button>
				  </div>
				  <div className="sass">
				    <p className="sass__paragraph">
				      In this project, I used advanced CSS and SASS animations to build up this awesome touristique website.Besides,
				      I used media queries to insure that the website is full responsive.
				    </p>
				    <button className="btn">
				      <a href='https://daliagadelhak.github.io/Tourism/index.html' target='_blank'>
				        <span className="btn__visible"style={{marginLeft:"30px"}}>Click Here!</span>
				        <span className="btn__invisible">See Full Project!</span>
				      </a>
				    </button>
				  </div>
				  <div className="js">
				    <p className="js__paragraph">
				      This is a small 'ROCK,PAPER,SCISSORS' game, in which I used only vanilla js without any framework. <br/>
				      <button className="btn">
				        <a href="https://daliagadelhak.github.io/Rock Paper Scissor game/index.html" target='_blank'>
				          <span className="btn__visible" style={{marginLeft:"30px"}}>Click Here!</span>
				          <span className="btn__invisible">See Full Project!</span>
				        </a>
				      </button>
				    </p>
				  </div>
				</section>



				<footer className="footer">
				  <p>
				    &copy;Dalia Gadelhak 2020</p>
				</footer>
			:
			  	null
			}

			  {
			  	showInfo
			  ?
			  	<div className="info-overlay">
				    <div className="info-container">
				      <h3 style={{margin: "3rem auto"}}>Personal Information</h3>
				      <p style={{margin: "2rem auto"}}>
				        <strong>Telephone Number:</strong> (+41)787271715<br/>
				        <strong>Email-address:</strong> daliagadelhak@gmail.com <br/>

				      </p>
				      <button 
				      	className="close-btn"
				      	onClick={()=>setShowInfo(false)}
				      >
				        <i className="fas fa-times"></i>
				      </button>
				    </div>
				  </div>
			  :
			  	null
			  }
			</div>
		:
			null
		}
		{
			showItem === 'book site'
		?
			<div>
	        	<Navigation />
				<Showcase />
				<About />
				<Author />
				<Contact />
				<Footer />
			</div>
		:
			null
		}
		{
			showItem === 'grades'
		?
          	<div>
	          	<Navigation />
	          	<GradeLessons id={id} />
          	</div>
	    :
			null
		}
	         
	    {
			showItem === 'log in'
		?
        	<div>
	        	<Navigation />
	        	<Log_in/>
        	</div>
        :
			null
		}
		{
			showItem === 'sign in'
		?
			<div>
				<Navigation />
				<Sign_in/>
			</div>
		:
			null
		}
		</div>
	)
}